var map = {
	"./ashford/taxonomy.json": 876,
	"./breckland/taxonomy.json": 877,
	"./broxbourne/taxonomy.json": 878,
	"./cardiff/taxonomy.json": 879,
	"./darlington/taxonomy.json": 880,
	"./demo/taxonomy.json": 881,
	"./haringey/taxonomy.json": 882,
	"./hfh/taxonomy.json": 883,
	"./hull/taxonomy.json": 884,
	"./kirklees/taxonomy.json": 885,
	"./leicester/taxonomy.json": 886,
	"./northgate/taxonomy.json": 887,
	"./preston/taxonomy.json": 888,
	"./rushcliffe/taxonomy.json": 889,
	"./selby/taxonomy.json": 890,
	"./sholland/taxonomy.json": 891,
	"./slough/taxonomy.json": 892,
	"./southglos/taxonomy.json": 893,
	"./telford/taxonomy.json": 894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;